import { render, staticRenderFns } from "./WindowsLogo.vue?vue&type=template&id=48b6efcc&"
import script from "./WindowsLogo.vue?vue&type=script&lang=ts&"
export * from "./WindowsLogo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48b6efcc')) {
      api.createRecord('48b6efcc', component.options)
    } else {
      api.reload('48b6efcc', component.options)
    }
    module.hot.accept("./WindowsLogo.vue?vue&type=template&id=48b6efcc&", function () {
      api.rerender('48b6efcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/icons/WindowsLogo.vue"
export default component.exports